var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00148 1.12463L2.01927 4.53116C1.60384 4.78042 1.43769 5.19585 1.52077 5.69436C2.01929 7.52226 3.59792 12.3413 8.00148 14.9169C8.33382 15.0831 8.66618 15.0831 8.99852 14.9169C13.4021 12.3413 14.9807 7.60535 15.4792 5.69436C15.5623 5.27893 15.3962 4.78042 14.9807 4.53116L8.99852 1.12463C8.66618 0.958457 8.33382 0.958457 8.00148 1.12463Z",
    stroke: "#5A68E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.befe6460f943366d1bbf855f84cc1f7d.svg";
export { ForwardRef as ReactComponent };